import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "Bench",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "Bench",
    description: "Bench",
    image: require("./Bench.svg"),
    svgIcon: require("./Bench.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 50,
      max: 250,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 35) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M96.41,61.77v2.79c1.27.49,1.27.49,1.27,1.91,0,2.35,0,4.71,0,7.07,0,.84-.1,1.51-1.16,1.34-.38,1.58-.38,1.58-2,1.58h-3c-1.51,0-1.51,0-1.73-1.51H10.11c-.29,1.51-.29,1.51-1.83,1.51H5.1c-1.52,0-1.52,0-1.71-1.55C2.07,75.1,2,74.28,2,73.26c.05-2.29,0-4.58,0-6.87,0-1.46,0-1.46,1.38-1.74V61.89c-1.38-.44-1.38-.44-1.38-1.94,0-2.29,0-4.59,0-6.88,0-1,.15-1.66,1.39-1.48v-3C2.16,48.75,2,48.05,2,47c.06-2.39.05-4.78,0-7.17,0-1,.18-1.59,1.44-1.42,0-1.24,0-2.42,0-3.59,0-.86.3-1.2,1.17-1.17,1.36,0,2.72.06,4.08,0,1,0,1.34.3,1.29,1.25-.05,1.12,0,2.25,0,3.44h9c0-1.7,0-3.39,0-5.07,0-.17-.48-.46-.75-.47-1.66,0-3.32,0-5,0-3.32,0-6.64,0-10,0-.86,0-1.22-.27-1.17-1.15s0-1.65,0-2.48c0-1.24.08-1.32,1.28-1.32H18.88c0-.52.08-1,.06-1.41,0-.75.26-1.1,1-1.06s1.86.05,2.79,0,1.31.29,1.22,1.2c0,.36,0,.73,0,1.18H75.61c0-.43,0-.88,0-1.33,0-.77.32-1.08,1.08-1.05a23.6,23.6,0,0,0,2.79,0c.93-.06,1.29.32,1.22,1.22,0,.36,0,.72,0,1.26H96.34c1.25,0,1.33.09,1.34,1.37v2.19c0,1.29-.09,1.38-1.35,1.38-4.84,0-9.69,0-14.54,0-.85,0-1.17.2-1.13,1.1.07,1.45,0,2.92,0,4.46H89.9c0-1.18,0-2.37,0-3.55,0-.81.28-1.14,1.1-1.12q2.15.06,4.29,0c.83,0,1.12.32,1.1,1.13,0,1.15,0,2.31,0,3.54,1.23-.05,1.34.69,1.32,1.63q-.06,3.59,0,7.17c0,.89-.15,1.52-1.26,1.47v2.93c1.31-.14,1.27.73,1.26,1.67,0,2.36,0,4.71,0,7.07C97.71,61.18,97.55,61.82,96.41,61.77ZM10.05,73.87H89.9c0-2.39-.05-4.71,0-7,0-.91-.23-1.17-1.16-1.17q-38.82,0-77.66,0c-.34,0-.69,0-1,.06Zm0-26.26h77.3a12.89,12.89,0,0,1,1.39,0c.87.1,1.23-.16,1.19-1.13-.08-2-.08-4,0-6,0-.95-.3-1.14-1.18-1.14q-38.79,0-77.59,0H10Zm0,13.16H88.32a5.43,5.43,0,0,1,.7,0c.72.08.9-.26.89-.93,0-2.06-.07-4.12,0-6.17,0-.94-.28-1.16-1.17-1.15q-38.8,0-77.59,0H10ZM75.56,32.89H24.08v5.49H75.56Zm21.33-4H2.83v2.9H96.89ZM90.63,75.41h5V34.72h-5ZM4.29,34.69V75.46H9.18V34.69Zm71.27,14H24.08v2.9H75.56Zm-51.5,16H75.52V61.77H24.06Zm61.2-16.14c-.8,0-1.59,0-2.39,0-2.56.07-2.13-.55-2.2,2.28,0,.63.25.79.83.79,2,0,4.1,0,6.16,0,2.37,0,2.35,0,2.25-2.34,0-.57-.24-.74-.77-.73C87.84,48.57,86.55,48.55,85.26,48.55Zm.06,16.22h2.39c2.24,0,2.2,0,2.2-2.19,0-.72-.26-.89-.92-.88-2.06,0-4.11,0-6.17,0-2.5,0-2.08-.52-2.15,2.23,0,.67.25.86.88.84C82.8,64.75,84.06,64.77,85.32,64.77ZM18.81,48.62H10.07v3h6.41c2.68,0,2.68,0,2.44-2.71A2.79,2.79,0,0,0,18.81,48.62ZM10,64.77c2.89,0,5.61,0,8.32,0,.22,0,.56-.39.61-.64a13.43,13.43,0,0,0,0-1.68c0-.5-.16-.72-.68-.72-2.55,0-5.11,0-7.66,0a.84.84,0,0,0-.59.54C10,63.05,10,63.84,10,64.77Zm9.73-31.92v5.5h3.44v-5.5Zm56.69,5.53H79.9V32.89H76.41ZM23.2,48.64H19.7v2.9h3.5Zm53.22,0v2.93h3.46V48.59ZM19.65,61.77c0,.89,0,1.68,0,2.46a.76.76,0,0,0,.52.51c1,.05,2,0,3,0v-3Zm60.27,0h-3.5v2.91h3.5ZM3.47,69.87c0-1.19,0-2.38,0-3.57,0-.19-.22-.38-.34-.57-.13.19-.36.37-.36.56q0,3.52,0,7c0,.19.23.38.35.57.12-.19.34-.37.35-.56C3.49,72.19,3.47,71,3.47,69.87Zm-.3-22.22.3-.19c0-2.49,0-5,0-7.46,0-.2-.21-.39-.33-.59-.13.19-.37.38-.37.56,0,2.36,0,4.71,0,7.07C2.77,47.25,3,47.45,3.17,47.65Zm0,13.16.3-.19c0-2.49,0-5,0-7.46,0-.2-.21-.39-.33-.59-.13.19-.37.37-.37.56,0,2.35,0,4.71,0,7.06C2.76,60.4,3,60.61,3.17,60.81Zm20-34.37H19.71v1.35H23.2Zm56.68,1.43V26.43H76.42v1.38c.2,0,.36.05.52.05Zm17,37.68c-.66.9-.61,7.83,0,8.41Zm0-18V39.2C96.19,40.24,96.25,47,96.79,47.59Zm.07,4.78c-.71,1-.62,7.91,0,8.35Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M10.05,73.87V65.76c.36,0,.71-.06,1-.06q38.84,0,77.66,0c.93,0,1.18.26,1.16,1.17-.07,2.31,0,4.63,0,7Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M10,47.61V39.39h1.11q38.79,0,77.59,0c.88,0,1.22.19,1.18,1.14-.08,2-.08,4,0,6,0,1-.32,1.23-1.19,1.13a12.89,12.89,0,0,0-1.39,0H10Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M10,60.77V52.54h1.12q38.79,0,77.59,0c.89,0,1.2.21,1.17,1.15-.08,2,0,4.11,0,6.17,0,.67-.17,1-.89.93a5.43,5.43,0,0,0-.7,0H10Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M75.56,32.89v5.49H24.08V32.89Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M96.89,28.89v2.9H2.83v-2.9Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M90.63,75.41V34.72h5V75.41Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M4.29,34.69H9.18V75.46H4.29Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M75.56,48.64v2.9H24.08v-2.9Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M24.06,64.69V61.77H75.52v2.92Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M85.26,48.55c1.29,0,2.58,0,3.88,0,.53,0,.74.16.77.73.1,2.34.12,2.34-2.25,2.34-2.06,0-4.11,0-6.16,0-.58,0-.84-.16-.83-.79.07-2.83-.36-2.21,2.2-2.28C83.67,48.53,84.46,48.55,85.26,48.55Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M85.32,64.77c-1.26,0-2.52,0-3.77,0-.63,0-.89-.17-.88-.84.07-2.75-.35-2.18,2.15-2.23,2.06,0,4.11,0,6.17,0,.66,0,.92.16.92.88,0,2.19,0,2.19-2.2,2.19Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M18.81,48.62a2.79,2.79,0,0,1,.11.28c.24,2.71.24,2.71-2.44,2.71H10.07v-3Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M10,64.77c0-.93,0-1.72,0-2.5a.84.84,0,0,1,.59-.54c2.55,0,5.11,0,7.66,0,.52,0,.7.22.68.72a13.43,13.43,0,0,1,0,1.68c-.05.25-.39.64-.61.64C15.6,64.78,12.88,64.77,10,64.77Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M19.72,32.85h3.44v5.5H19.72Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M76.41,38.38V32.89H79.9v5.49Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M23.2,48.64v2.9H19.7v-2.9Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M76.42,48.59h3.46v2.93H76.42Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M19.65,61.77h3.54v3c-1,0-2,0-3,0a.76.76,0,0,1-.52-.51C19.61,63.45,19.65,62.66,19.65,61.77Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M79.92,61.77v2.91h-3.5V61.77Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M3.47,69.87c0,1.16,0,2.32,0,3.48,0,.19-.23.37-.35.56-.12-.19-.35-.38-.35-.57q0-3.53,0-7c0-.19.23-.37.36-.56.12.19.33.38.34.57C3.49,67.49,3.47,68.68,3.47,69.87Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M3.17,47.65c-.14-.2-.4-.4-.41-.61,0-2.36,0-4.71,0-7.07,0-.18.24-.37.37-.56.12.2.33.39.33.59,0,2.49,0,5,0,7.46Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M3.17,60.81c-.14-.2-.41-.41-.41-.62,0-2.35,0-4.71,0-7.06,0-.19.24-.37.37-.56.12.2.33.39.33.59,0,2.49,0,5,0,7.46Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M23.2,26.44v1.35H19.71V26.44Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M79.88,27.87H76.94c-.16,0-.32,0-.52-.05V26.43h3.46Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M96.84,65.55V74C96.23,73.38,96.18,66.45,96.84,65.55Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M96.79,47.59c-.54-.56-.6-7.35,0-8.39Z"
              transform="translate(-2.03 -25.39)"
            />
            <path
              class="cls-1"
              d="M96.86,52.37v8.35C96.24,60.28,96.15,53.34,96.86,52.37Z"
              transform="translate(-2.03 -25.39)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
